import React from 'react';
import './App.scss';
import AppWithRouterAccess from './AppWithRouterAccess.jsx';

const App = () => {
    return   (
    <AppWithRouterAccess/>
  )
}


export default App;
